import React from 'react';
import ErrorTemplate from '../ErrorTemplate';

class Error404 extends React.Component {
  render() {
    return (
      <div>     
     
         <ErrorTemplate
        errorCode="404"
        errorMessage="Page Not Found"
      />
      </div>

    );
  }
}

export default Error404;